var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-date-picker',{staticStyle:{"width":"300px"},attrs:{"type":"daterange","range-separator":"至","start-placeholder":"开始日期","end-placeholder":"结束日期","disabled":_vm.disabled?_vm.disabled:false},on:{"change":_vm.change},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }